<template>
    <div>
        <test-template :testName="testName" :testId="testId" :test="test" @saveResults="getPhysicalActivityResults">
            <template #questions>
                <b-card class="neu-card">
                    <h1>{{ cQ.intensity.toUpperCase() }}</h1>
                    <h4 v-html="cQ.question"></h4>
                    <div v-if="cQ.id === 'q1' || cQ.id === 'q3' || cQ.id === 'q5'">
                        <b-row>
                            <b-col class="d-flex justify-content-center">
                                <div class="d-inline-flex">
                                    <b-row>
                                        <b-col cols="12" sm="12" md="6" lg="6">
                                            <base-input class="inputAnswer" type="number" v-model="cQ.result" :placeholder="$t('days')" :min=0 :max=7>
                                            </base-input>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col v-if="cQ.result && cQ.result > 0 && cQ.result <= 7" xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                <transition name="fade" appear>
                                    <button type="button" class="btn btn-primary w-100" @click.once="$store.commit('tests/incrementSlide')">
                                        <span class="text-center">{{ cQ.result }} {{ $t('days') }}</span>
                                        <span class="float-right m-auto"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/></span>
                                    </button>
                                </transition>
                            </b-col>
                            <b-col v-else-if="cQ.result == 0" xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                <transition name="fade" appear>
                                    <button type="button" class="btn btn-primary w-100" @click.once="$store.commit('tests/incrementSlide', 2)">
                                        <span class="text-center">{{ cQ.result }} {{ $t('days') }}</span>
                                        <span class="float-right m-auto"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/></span>
                                    </button>
                                </transition>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <b-row>
                            <b-col class="d-flex justify-content-center">
                                <div class="d-inline-flex">
                                    <b-row>
                                        <b-col cols="12" sm="12" md="6" lg="6">
                                            <base-input class="inputAnswer" type="number" v-model="physicalActivity.hour" :placeholder="$t('tests.sleep-quality.hours')" :min=0 :max=23>
                                                <template slot="append">
                                                    <span>h</span>
                                                </template>
                                            </base-input>
                                        </b-col>
                                        <b-col cols="12" sm="12" md="6" lg="6">
                                            <base-input class="inputAnswer" type="number" v-model="physicalActivity.minutes" :placeholder="$t('tests.sleep-quality.minutes')" :min=0 :max=59>
                                            <template slot="append">
                                                    <span>min</span>
                                                </template>
                                            </base-input>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col v-if="(physicalActivity.hour != 0 || physicalActivity.minutes != 0) && (physicalActivity.hour >= 0  && physicalActivity.minutes >= 0 && physicalActivity.hour < 24 && physicalActivity.minutes < 60)" xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                <transition name="fade" appear>
                                    <button type="button" class="btn btn-primary w-100" @click.once="calculateMinutes()">
                                        <span class="text-center">{{ physicalActivity.hour  }} {{ $t('tests.sleep-quality.hours')}} {{ physicalActivity.minutes }} {{ $t('tests.sleep-quality.minutes')}}</span>
                                        <span class="float-right m-auto"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/></span>
                                    </button>
                                </transition>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </template>
            <template #results>
                <div key="topGraph" class="first">
                        <h3 class="subtitle-card text-center">{{ $t('tests.testResults') }} - {{ testName.toUpperCase() }}</h3>
                        <column-chart :lastYearResults="$store.state.tests.previousTestResults.slice(-12)" :testName="testName" :customChart="chartValues"></column-chart>
                    </div>
                    <div key="recapCard" class="second">
                        <h4>{{ $t('tests.results') }} {{ month }}</h4>
                        <b-card class="neu-card mean-result col-lg-7">
                            <h3 class="subtitle-card"> {{ testName }}</h3>
                            <h5 class="subtitle-card" :style="`color: ${resultInfo.color}`"> {{ resultInfo.tag.toUpperCase() }}</h5>
                            <p class="p-white" v-html="resultInfo.resultAnalysis"></p>
                        </b-card>
                    </div>
                    <small>{{ $t('tests.physical-activity.metsExplanation') }}</small>
            </template>
        </test-template>
    </div>
</template>

<script>
import TestTemplate from './TestTemplate.vue'
import { BCollapse, BProgress } from 'bootstrap-vue'
import { Chart } from 'highcharts-vue'
import { TEST_PHYSICAL_ACTIVITY } from '@/constants/patientServices'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'
import { GRAY_COLOUR } from '@/constants/colours'
import { formatDateByMonthLong } from '@/helpers/date.helpers'

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'test-template': TestTemplate,
        BCollapse,
        BProgress,
        'highcharts': Chart,
        'column-chart': () => import('@/components/charts/ColumnChart.vue')
    },
    data () {
        var _this = this
        const chartValues = {
            tooltip: {
                formatter: function () {
                    return `<b>${formatDateByMonthLong(this.point.date).replace(/^\w/, c => c.toUpperCase())}</b><br>
                            ${_this.$t('tests.physical-activity.levels.name')}: <b>${this.point.y}METS</b>`
                }
            },
            yAxis: {
                title: null,
                // tickPositions: [0, 8, 13], MUY PARECIDO A LO QUE HACE EL TEST DE DIETA MEDITERRÁNEA
                // tickLength: 1,
                // labels: {
                //     formatter: function () {
                //         return this.value === 0 ? '' : this.value === 8 ? _this.$t('tests.mediterranean-diet.scores.goodAdherence.name') : ''
                //     }
                // },
                // labels: {
                //     enabled: false
                // },
                // tickInterval: 13,
                // max: 13,
                gridLineWidth: 0.4,
                gridLineColor: GRAY_COLOUR
            }
        }
        return {
            test: [],
            testId: TEST_PHYSICAL_ACTIVITY,
            testName: this.$t('tests.physical-activity.title'),
            physicalActivity: {},
            chartValues: chartValues
        }
    },
    created () {
        this.createQuestions()
    },
    methods: {
        createQuestions () {
            const totalQuestions = 7
                for (let i = 1; i <= totalQuestions; i++) {
                    this.test.push({
                        id: `q${i}`,
                        question: this.$t(`tests.physical-activity.questions.q${i}`),
                        intensity: i <= 2 ? this.$t('tests.physical-activity.intensity.intense') : i <= 4 ? this.$t('tests.physical-activity.intensity.moderate') : i <= 6 ? this.$t('tests.physical-activity.intensity.walking') : this.$t('tests.physical-activity.intensity.sitting'),
                        result: i === 1 || i === 3 || i === 5 ? null : 0
                    })
                }
        },
        getPhysicalActivityResults () {
            var intenseMets = 8 * this.test[0].result * this.test[1].result
            var moderateMets = 4 * this.test[2].result * this.test[3].result
            var walkingMets = 3.3 * this.test[4].result * this.test[5].result
            const result = Math.round(intenseMets + moderateMets + walkingMets)
            this.save(this.test.map(x => { return {'id': x.id, 'result': x.result} }), result, this.getDiagramPercent(result))
        },
        calculateMinutes () {
            this.cQ.result = parseInt(this.physicalActivity.hour) * 60 + parseInt(this.physicalActivity.minutes)
            this.physicalActivity = {
                hour: 0,
                minutes: 0
            }
            if (this.$store.state.tests.currentSlide <= this.test.length - 2) {
                this.$store.commit('tests/incrementSlide')
            } else {
                this.getPhysicalActivityResults()
            }
        },
        getDiagramPercent (mets) {
            if (mets >= 3000 || (mets >= 1500 && this.test[0].result >= 3)) {
                return 100
            } else if (mets >= 600 || (this.test[0].result >= 3 && this.test[1].result >= 20) || (this.test[2].result + this.test[4].result >= 5 && this.test[3].result + this.test[5].result >= 30)) {
                return 50
            } else {
                return 0
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/PhysicalActivityTest.vue